import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";

export default function AiSuggest({ kind, context, onResults, label = "AI Suggest" }) {
  const [loading, setLoading] = useState(false);

  const run = async () => {
    setLoading(true);
    try {
      const res = await api.post("/ai/suggest", { kind, context });
      const suggestions = res.data.suggestions || [];
      if (!suggestions.length) {
        toast.info("No suggestions returned, try adding more detail.");
      } else {
        onResults(suggestions);
        toast.success(`${suggestions.length} AI suggestions added`);
      }
    } catch (e) {
      toast.error("AI suggestion failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      data-testid={`ai-suggest-${kind}`}
      onClick={run}
      disabled={loading}
      className="inline-flex items-center gap-2 text-sm font-medium px-3 py-1.5 rounded-md bg-emerald-50 text-emerald-700 hover:bg-emerald-100 border border-emerald-200 transition-colors disabled:opacity-60"
    >
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Sparkles className="h-4 w-4" />}
      {loading ? "Thinking…" : label}
    </button>
  );
}
